<template>
  <div>
     <DxSelectBox
              :search-enabled="true"
              :data-source="gridDataSource"
              :search-mode="searchModeOption"
              :search-expr="searchExprOption"
              :search-timeout="searchTimeoutOption"
              :min-search-length="minSearchLengthOption"
              :show-data-before-search="showDataBeforeSearchOption"
              :accept-custom-value="true"
              display-expr="name"
              :disabled="disabled"
              value-expr="id"
              :value="gridBoxValue"                            
              ref="rltfld"
              @value-changed="onValueChanged"
            />
            
  </div>
</template>

<script>
import { DxSelectBox} from 'devextreme-vue/select-box';
import CustomStore from "devextreme/data/custom_store";

export default {
  props: {
    rRoute: String,
    slug: String,
    modelValue:String,
    disabled:Boolean,
  },
  components: {
	DxSelectBox,
   
  },
  data() {
    return {
      gridDataSource: null,
      gridBoxValue: "",
      searchModeOption: 'contains',
      searchExprOption: 'name',
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      
      showDataBeforeSearchOption: true,
    };
  },
  methods: {
    makeAsyncDataSource(rRoute, slug) {
      console.log("RELATE COMPONENT world",rRoute,slug);

      return new CustomStore({
       
        key: "id",
        loadMode: 'processed',
        load: function (loadOptions) {
        let listurl = "/" + slug + "/" + rRoute + "/list";

        //  let listurl = "/" + slug + "/" + rRoute + "/field/rlt_fld_build_relate";

          console.log("RELATE COMPONENT list url",listurl)

          var parameters = {};

          var tFilter =[loadOptions.searchExpr,loadOptions.searchOperation,loadOptions.searchValue] ;

            if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          if(loadOptions.searchExpr !=null && loadOptions.searchValue !=null ){
          parameters.filter = JSON.stringify(tFilter);
          }
          var config = {
            params: parameters,
          };

          return axios
            .get(listurl,config)
            .then((response) => {

              console.log("RELATE COMPONENT Response",response.data.results.data);
              return  {
                data: response.data.results.data,
                totalCount: response.data.results.total,
              };
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        byKey:  function (key) { 

          if (key != null || key !== 'undefined')
          {
            
            let url= "/"+slug+"/"+rRoute+'/getById/'+key;
            return axios
              .get(url)
              .then((response) => { 
              // console.log("RELATE COMPONENT byKey Response",response);

                return  {  
                  id: response.data.data.id,
                  name: response.data.data.name,
                };
              })
              .catch(() => {
                throw "Data Loading Error";
              });
          }
          
          //return { id: key, name: "Unknown" };
        },
         
      });
    },
    onValueChanged(e) {
      console.log("Relate Component se Modelvalue emit hua ",e.value);

      this.$emit("update:modelValue", e.value);
    
    },
  },
  mounted() {
        
    console.log("dsd",this.modelValue);
    this.gridBoxValue=this.modelValue;
    console.log("Route and slug",this.rRoute, this.slug);
    

    this.gridDataSource = this.makeAsyncDataSource(this.rRoute, this.slug);
    //this.gridBoxValue={id:"d91433edfba944cf82e4af56cabf906c",name:"Rahul"};
    //this.gridBoxValue="d91433edfba944cf82e4af56cabf906c";
    //console.log(this.$refs["rltfld"].instance.getValue());
  },
};
</script>

<style>
</style>